import { useQuery } from '@tanstack/react-query';
import { listEligibleAppointmentCounselors } from '../api/personalAppointments';

/** "Assign Counselors" (Phase 77) — mirrors useCounselorOptions.ts, but
 * backed by GET /personal-appointments/eligible-counselors (gated on
 * personal_appointments:create, which every role that can open the
 * Convert-to-Personal-Appointment dialog already holds) rather than
 * GET /leads/eligible-counselors (leads:assign) — a plain Counselor
 * creating their own appointment doesn't hold leads:assign. */
export const useEligibleAppointmentCounselors = (enabled: boolean) => {
  const query = useQuery({
    queryKey: ['personal-appointments', 'eligible-counselors'],
    queryFn: listEligibleAppointmentCounselors,
    enabled,
  });

  return {
    counselors: query.data ?? [],
    isLoading: query.isLoading,
  };
};
